exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".StandardLayout-c9783ebb{display:flex;min-height:100vh;flex-direction:column}.content-15733184{flex:1 0 auto}.greyBg-bd8a2df7{background:#f5f5f5}\n", ""]);

// Exports
exports.locals = {
	"StandardLayout": "StandardLayout-c9783ebb",
	"content": "content-15733184",
	"greyBg": "greyBg-bd8a2df7"
};